import {
  InAppContentService,
  KnowledgeSource,
  CreateKnowledgeSourceRequest,
  UpdateKnowledgeSourceRequest,
} from '@beeboard/common';
import { defineStore } from 'pinia';

type KnowledgeSourceStoreState = {
  sources: KnowledgeSource[];
  isLoaded: boolean;
};

export const useKnowledgeSourceStore = defineStore('knowledgeSourceStore', {
  state: (): KnowledgeSourceStoreState => ({
    sources: [],
    isLoaded: false,
  }),

  actions: {
    async loadSources() {
      const sources = await InAppContentService.getKnowledgeSources();
      this.sources = sources;
      this.isLoaded = true;
    },

    async createSource(data: CreateKnowledgeSourceRequest) {
      const source = await InAppContentService.createKnowledgeSource(data);
      this.sources.push(source);

      return source;
    },

    async updateSource(sourceId: string, data: UpdateKnowledgeSourceRequest) {
      const source = await InAppContentService.updateKnowledgeSource(
        sourceId,
        data,
      );
      const index = this.sources.findIndex((s) => s.id === sourceId);
      if (index !== -1) {
        this.sources[index] = source;
      }

      return source;
    },

    async deleteSource(sourceId: string) {
      await InAppContentService.deleteKnowledgeSource(sourceId);
      this.sources = this.sources.filter((s) => s.id !== sourceId);
    },
  },
});
